export class QuizMapper {
  static mapToQuizList(response) {
    const responseList = response
    const list = []
    if (responseList.length > 0) {
      responseList.forEach(data => {
        const quiz = {
          id: data.id,
          lessonSlug: data.lessonSlug,
          name: data.name,
        }
        list.push(quiz)
      })
    }
    return list
  }
  static mapToQuizDetail(response) {
    const quizDetail = {
      quiz: {
        id: response.quiz._id,
        name: response.quiz.name,
        reward: response.quiz.reward,
        lessonSlug: response.quiz.lessonSlug,
        questions: [],
        myScore: 0
      },
      lessonDetail: this.mapToLessonDetail(response.lessonDetails)
    }
    if (response.quiz.questions?.length > 0) {
      response.quiz.questions.forEach(data => {
        if (data.question.type !== 'definition') {
          const questionDetail = {
            question: {
              id: data.question._id,
              options: data.question.options,
              selected: data.question.type === 'single' ? null : [],
              solution: data.question.solution,
              questionText: data.question.question,
              lessonSlug: data.question.lessonSlug,
              type: data.question.type,
            },
            score: data.socre // spelling wrong
          }
          quizDetail.quiz.questions.push(questionDetail)
        }
      })
    }
    return quizDetail;
  }
  static mapToQuizQuestions(response) {
    const questions = [];
    if (response.length > 0) {
      response.forEach(data => {
        if (data.type !== 'definition') {
          const questionDetail = {
            id: data._id,
            options: [],
            selected: data.type === 'single' ? null : [],
            solution: data.solution,
            questionText: data.question,
            lessonSlug: data.lessonSlug,
            type: data.type,
          }
          data.options.forEach(option => {
            const obj = {
              value: option,
              text: option,
            }
            questionDetail.options.push(obj)
          })
          questions.push(questionDetail)
        }
      })
    }
    return questions;
  }
  static mapToLessonDetail(response) {
    const lessonDetail = {
      lessonId: response.lesson_id,
      lessonName: response.lesson_name,
      lessonSlug: response.lession_slug, // correct spelling lesson
      list: []
    }
    if (response.data?.length > 0) {
      response.data.forEach(lesson => {
        const obj = {
          id: lesson.id,
          title: lesson.title,
          slug: lesson.slug,
          videoLength: lesson.video_length,
        }
        lessonDetail.list.push(obj)
      })
    }
    return lessonDetail;
  }
  static mapToChoiceQuestionJson(data) {
    const request = {
      question: data.questionText,
      name: data.questionText,
      lessonSlug: data.lessonSlug,
      options: [],
      solution: [],
      type: data.type,
    }
    data.options.forEach(option => {
      if (option.value !== '') {
        request.options.push(option.value)
      }
    })
    if (data.type === 'single') {
      request.solution.push(data.solution)
    } else { 
      request.solution = [...data.solution.filter(solution => solution !== '')]
    }
    return request
  }
}
